// import _ from "@/common/lodash-common";
import { steps } from "@/components/stepper/stepper";

const state = {
    steps,
    step: 'CeramicTiles'

};

const getters = {
    getStepByComponent: state => component => {
        return state.steps.find(step => step.component === component);
    },
    currentStep(state, getters) {
        const step = getters.getStepByComponent(state.step);
        if (!step) {
            throw "Step item " + state.step + " not found.";
        }
        return step;
    },
    forwardBtnDisabled(state) {
        switch (state.step) {
            case "TimeStep":
                return !state.selectedTime || !state.selectedDate;
                break;

            case "ClientStep":
                return !state.clientValidated;
                break;

            default:
                return false;
                break;
        }
    },
};
const mutations = {
    // SET_STEP: (state, payload) => {
    //     SET(state, payload);
    // }
};
const actions = {
    setStepByIndex({ state, commit }, index) {
        const step = state.steps.find((item) => item.index === index);
        if (!step) throw "_stepper.store.js: Cant find step with index " + index;

        commit("SET", { step: step.component });
    },
    nextStep({ getters, commit, dispatch }, context) {
        const step = getters.currentStep.nextStep;
        if (step) {
            commit("SET", { step });
            return;
        }
        // dispatch("setStepByIndex", getters.currentStep.index + 1);
    },
    previousStep({ getters, commit, dispatch }, context) {
        const step = getters.currentStep.previousStep;
        if (step) {
            commit("SET", { step });
            return;
        }

        context.$router.push({ name: 'Home', query: context.$route.query })
    },
};

export default {
    namespaced: false,
    state,
    getters,
    mutations,
    actions,
};
